import React from "react"

import Link from "../../utils/link"

import "./BookSection.scss"

const BookSection = (props) => {
  return (
    <section className="book-section">
      <div className="book-section__room-text">
        <div className="book-section__room-text__room">{props.acf.card.title}</div>
        <div className="book-section__room-text__sleep">Sleeps {props.acf.card.sleeps}</div>
      </div>
      <div className="divider" />
      <div className="book-section__container">
        <div className="book-section__container__text">
          {props.acf.title}
        </div>
        <Link to={'#booking-frame'} className="book-section__container__button">
          {props.acf.button.text}
        </Link>
      </div>
      <div className="divider" />
    </section>
  )
}

export default BookSection
